import Platform from '@core/api/Platform'

export default Platform
